module.exports = __webpack_public_path__ + "videos/mts-products-chats-ai-assistant.8d9173c.mp4";